module.exports = {
  locales: ['en-US', 'en', 'de', 'fr'],
  publicLocales: ['en-US', 'en', 'de'],
  defaultLocale: 'en',
  localesLabel: {
    en: 'English (Global)',
    'en-US': 'English (US)',
    de: 'Deutsch',
    fr: 'Français',
  },
};
